import { GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetResponse } from '@/generated'
import { formatDateTime } from '@/lib/utils'
import { ITEM_PER_PAGE } from './billing-history-definition'

const formatCurrency = (value: number, locale = 'en-US', currency = 'USD') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(value)
}

export interface IBillingHistoryItem {
  amount: string
  id: string
  created: string
  currency: string
  downloadPdf: string
  number: string
  status: string
  viewUrl: string
}
interface BillingHistoryTablet {
  hasMore: boolean
  items: IBillingHistoryItem[]
}

export const billingHistoryResponseDTO = (
  values: GetBillingHistoryOrganizationOrganizationIdBillingHistoryGetResponse,
  page: number
): BillingHistoryTablet => {
  return {
    hasMore: values.has_more,
    items: values.items.map((item, index) => ({
      count: (page - 1) * ITEM_PER_PAGE + index + 1,
      amount: formatCurrency(item.amount),
      id: item.id,
      created: formatDateTime(item.created),
      currency: item.currency,
      downloadPdf: item.download_pdf,
      number: item.number,
      status: item.status,
      viewUrl: item.view_url,
    })),
  }
}
